import * as React from 'react';
import { themePalette } from '../../../utils/theme-palette';

const LearningIcon = ({  size = 24, active = false }) => {
  const stroke = active ? themePalette.blue : themePalette.gray;
  const fill = active ? themePalette.blue : themePalette.white;

  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 10L14 4L27.5 10L14 16L0.5 10Z"
        fill={fill}
        stroke={stroke}
        strokeLinejoin="round"
      />
      <path
        id="top"
        d="M14.0453 10.4979C14.3203 10.4729 14.5229 10.2297 14.4979 9.95473C14.4729 9.67972 14.2297 9.47705 13.9547 9.50205L14.0453 10.4979ZM3 11L2.95473 10.5021C2.69719 10.5255 2.5 10.7414 2.5 11H3ZM13.9547 9.50205L2.95473 10.5021L3.04527 11.4979L14.0453 10.4979L13.9547 9.50205ZM2.5 11V20H3.5V11H2.5Z"
        fill={stroke}
      />
      <path
        id="border_bottom"
        d="M6 12.5L6 19.3924C6 20.0814 6.35494 20.7218 6.93922 21.087V21.087C11.2592 23.787 16.7408 23.787 21.0608 21.087V21.087C21.6451 20.7218 22 20.0814 22 19.3924V12.5"
        stroke={stroke}
        strokeLinejoin="round"
      />
      <path
        id="bottom_bit"
        d="M4 21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20C3.55228 20 4 20.4477 4 21Z"
        stroke={stroke}
      />
      <path
        id="bottom_bit2"
        d="M2.5 21.5L1.5 25L2.05132 25.1838C2.66712 25.389 3.33288 25.389 3.94868 25.1838L4.5 25L3.5 21.5"
        stroke={stroke}
        strokeLinejoin="round"
      />
      <path
        d="M22.5 12.2222L14 16L5.5 12.2222"
        stroke={active ? themePalette.white : themePalette.gray}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default LearningIcon;
